export default __webpack_public_path__ + "static/media/467.ecc3f63c.gif";